import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AriOSMarketing } from './pages/AriOSMarketing';
import { Conditions } from './pages/Conditions';
export function AppRouter() {
  return <BrowserRouter data-id="element-27" data-mp="stsk8vngx91q">
      <Routes data-id="element-28" data-mp="ss7myy9rrc06">
        <Route path="/" element={<AriOSMarketing data-id="element-30" data-mp="wukv1tbznm04" />} data-id="element-29" data-mp="ssqzfzgnh86t" />
        <Route path="/conditions" element={<Conditions data-id="element-32" data-mp="wt1es2qc1ayc" />} data-id="element-31" data-mp="wtszgiie5o9u" />
      </Routes>
    </BrowserRouter>;
}